import { filter, includes } from "lodash";
export default {
    methods: {
        /**
         *
         * @param {string|number} appointmentDate - The start date of the appointment in TIMESTAMP
         * @param {string} instanceId - The current instance Id to prevent the current instance trigger the socket
         * @description Only the current open census by the start date will trigger the API
         */
        refreshCensus(payload) {
            this.$socket.client.emit("v-broadcast-all", {
                action: "census-refresh",
                triggerFrom: "FE-refreshCensus",
                businessId: this.$root.setting.business_id,
                instance: payload.instanceId,
                params: { appointmentDate: Number(payload.appointmentDate), appointmentId: payload.appointmentId}
            });
        },
        checkoutDefaultDocuments(params) {
            // Auto select Invoice (4) and Wellness Plan (8) if self.checkout_data.default_documents is empty
            let defaultDocuments =
                Object.keys(params.dataDefaultDocuments)
                    .length > 0
                    ? params.dataDefaultDocuments
                    : ["4", "8"];

            const defaultDocs = filter(
                params.dataDocumentList,
                doc => includes(defaultDocuments, doc.id)
            );

            return defaultDocs
                ? defaultDocs
                : null;
        }
    }
};
